import {Injectable} from '@angular/core';
import {MeasurementService} from '../measurementAdapter/measurement.service';
import {Item} from '../../models/Item';
import {ItemManagerService} from '../itemManager/item-manager.service';
import {debounceTime} from 'rxjs/operators';
import {CesiumAdapterService} from '../cesiumAdapter21/cesium-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class CalculateInputsService {
  private badCalculations = {};
  private cachedPositionsByInput = {};
  private oldInputValues: object = {};

  constructor(
    private measurement: MeasurementService,
    private im: ItemManagerService,
    private adapter: CesiumAdapterService,
  ) {
    this.initOldValues();
  }

  public calculateItemInputs(item) {
    if (item.config.getInputs()) {
      const inputs = item.config.getInputs();
      const calculatedInputs = {};
      for (const i in inputs) {
        if (!inputs.hasOwnProperty(i)) {
          continue;
        }
        const input = inputs[i];
        if (input.hasOwnProperty('calculation')) {
          if (!calculatedInputs[i]) {
            calculatedInputs[i] = {};
          }
          calculatedInputs[i]['value'] = this.getMeasurementCalc(item, i, input.calculation);
        }
      }

      for (const i in calculatedInputs) {
        item.config.assignInput(i, calculatedInputs[i]);
      }
    }
  }

  private initOldValues(){
    this.im.itemsList.pipe(debounceTime(500)).subscribe((list)=>{
      for(let i in list){
        if (!list.hasOwnProperty(i)){
          continue;
        }
        let item:Item = list[i];
        if (!this.oldInputValues.hasOwnProperty(item.getId())){
          this.oldInputValues[item.getId()] = new Map();
        }

        for (let i in item.config.getInputs()){
          let input = item.config.getInputs()[i];
          if (input.hasOwnProperty('value') && input.value){
            this.oldInputValues[item.getId()].set(i, input.value);
          }
        }
      }
    });
  }

  public getMeasurementCalc(item, name, calculation) {

    if (name === 'uom') { // in theory this may be applied to all inputs
      calculation = calculation
        .replace(/item\.inputs\.([^\.]+)\.value/g, "(item.getConvertedInputValue ? item.getConvertedInputValue('$1') : item.inputs.$1.value)");
      if (this.measurement.isFeetMeasurement) {
        calculation = calculation.replace("'m'", "'ft'");
      }
    }
    const result = this.getSummaryCalculationValue(name, item, calculation);
    let measurementSystem =  this.measurement.getItemMeasurement(item);
    let signsAfterDot =  item.config.getInputProp(name, 'imperialprecision');
    let measurementResult = this.measurement.getMeasurementCalc(item, item.config.getInputByName(name), result, name);
    if (signsAfterDot && measurementSystem == 'imperial'){
      let resultArr = measurementResult.split(' ');
      measurementResult = parseFloat(parseFloat(resultArr[0]).toFixed(signsAfterDot))+' '+resultArr[1];
    }
    return measurementResult;
  }

  getSummaryCalculationValue(name, item, calculation) {
    let param = this.calculateObjectParam(item, calculation, name);
    const inputs = item.config.getInputs();
    if (name === 'quantity' && inputs.hasOwnProperty('uom')) {
      param += ' ' + inputs['uom']['value'];
    }

    // if (item.inputs[name].hasOwnProperty('originalValue') && item.inputs[name].hasOwnProperty('originalLabel')){
    //   console.log('getSummaryCalculationValue inside if');
    //   if (setCurrentConvert(item.inputs[name])){
    //     param = currentConvert.convert(param);
    //   }
    // }
    return param;
  }

  calculateObjectParam(item: Item, calculation, name) {
    if (!this.badCalculations.hasOwnProperty(item.getId())) {
      this.badCalculations[item.getId()] = {};
    }
    if (this.badCalculations[item.getId()].hasOwnProperty(name)) {
      return 'error';
    }
    const preparedCalculation = calculation;

    const input = item.config.getInputByName(name);
    if (calculation.indexOf('_3words') >= 0) {
      // console.log("Skip w3w calculation");
      if (!this.cachedPositionsByInput.hasOwnProperty(item.getId())) {
        this.cachedPositionsByInput[item.getId()] = {};
      }

      // if (this.cachedPositionsByInput[item.getId()][name]) { return input.value; }
      if (input.hasOwnProperty('value') && input.value) {
        if (
          this.cachedPositionsByInput[item.getId()][name]
          && this.cachedPositionsByInput[item.getId()][name].equals(item.config.getObjectConfig().getPosition())
        ) {
          return input.value;
        }
      }
      this.cachedPositionsByInput[item.getId()][name] = item.config.getObjectConfig().getPosition();
    }


    try {
      // var c = new Function('item', '$scope', preparedCalculation);
      const c = new Function('item',
        preparedCalculation
          .replace(/.getPosition\(\)/g, '.getHumanizedPosition()')
          .replace(/.position./g, '.getHumanizedPosition().')
          .replace(/.getPath\(\).getArray\(\)/g, '.getPath()')
          .replace(/ \$scope.getZoom\(\)/, this.adapter.currentZoom)
      );

      // var result = c(item, $scope);
      const result = c(item);

      if (
        !this.oldInputValues.hasOwnProperty(item.getId())
        || !this.oldInputValues[item.getId()].has(name)
        || this.oldInputValues[item.getId()].get(name) != result
      ) {
        item.config.setInputValue(name, 'value', result);
        if (!this.oldInputValues.hasOwnProperty(item.getId())) {
          this.oldInputValues[item.getId()] = new Map();
        }
        this.oldInputValues[item.getId()].set(name, result);
      }
      return result;
    } catch (e) {
      // console.log(item.objects[0].getHumanizedPosition())
      this.badCalculations[item.getId()][name] = e;
      console.error('Error during calculation', e );
      // console.error("error calculation" , preparedCalculation);
      // console.error("error calculation item" , item);
    }
  }
}

